const getFailsWidgets = (ctx) => {
  return {
    name: '',
    rightWidgets: [
      {
        icon: 'CreditCardIcon',
        code: 'successRate',
        name: ctx.$t('stats.countOfFails'),
        color: "warning",
        delimited: false,
        symbol: '',
        type: 'numberOfFails',
        data: null
      },
    ]
  }
}

export default getFailsWidgets